// Design tokens — per Growth Blueprint 2026 audit (Section 5.1)
// Source: NinjAthlete_Growth_Blueprint_2026.docx, Daniel review, Jun 22 2026.
export const TOKENS = {
  canvas:    '#0B0B0C',
  surface1:  '#15151A',
  surface2:  '#1E1E24',
  lime:      '#C7FA3E',   // ONE accent — primary CTAs, active states
  limeMuted: 'rgba(199, 250, 62, 0.10)',
  limeBorder:'rgba(199, 250, 62, 0.40)',
  text:      '#F5F5F5',
  textMuted: '#A1A1AA',
  textDim:   '#71717A',
  red:       '#E63946',   // legacy peptide category color (kept for tags only)
  cyan:      '#00F0FF',   // legacy hydrotherapy category color (kept for tags)
};

// Reusable inline styles
export const limeBtn = {
  backgroundColor: TOKENS.lime,
  color: '#0B0B0C',
  fontFamily: 'Anton, "Archivo Narrow", "Bebas Neue", sans-serif',
  letterSpacing: '0.04em',
};

export const limeOutlineBtn = {
  border: `1px solid ${TOKENS.limeBorder}`,
  color: TOKENS.lime,
  fontFamily: 'Anton, "Archivo Narrow", "Bebas Neue", sans-serif',
  letterSpacing: '0.04em',
};

export const displayFont = {
  fontFamily: 'Anton, "Archivo Narrow", "Bebas Neue", sans-serif',
  letterSpacing: '0.02em',
};
